import * as React from 'react'
import { api } from '../lib/api'
import Card from '@mui/joy/Card'
import Button from '@mui/joy/Button'
import Chip from '@mui/joy/Chip'

interface Notification {
  id: string
  type: string
  isRead: boolean
  createdAt: string
}

export default function Notifications() {
  const [rows, setRows] = React.useState<Notification[]>([])
  const load = async () => setRows(await api('/notifications'))
  React.useEffect(() => {
    load()
  }, [])
  return (
    <div className="max-w-5xl mx-auto p-6 space-y-3">
      <h2 className="text-2xl font-semibold">Notifications</h2>
      {rows.map((n) => (
        <Card key={n.id} variant="outlined" className="flex items-center justify-between">
          <div>
            <div className="font-semibold">{n.type}</div>
            <div className="text-sm opacity-60">{new Date(n.createdAt).toLocaleString()}</div>
          </div>
          <div className="flex gap-2">
            <Chip variant="soft">{n.isRead ? 'Read' : 'New'}</Chip>
            <Button
              variant="outlined"
              onClick={async () => {
                await api('/notifications/' + n.id + '/read', { method: 'POST' })
                load()
              }}
            >
              Mark read
            </Button>
          </div>
        </Card>
      ))}
    </div>
  )
}
